import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Download, FileText, ArrowRight } from 'lucide-react';
import { toast } from 'sonner';

export const CatalogCTASection = () => {
  const handleQuickDownload = () => {
    const link = document.createElement('a');
    link.href = '/catalogs/universa-surgical-brochure-2025.pdf';
    link.download = 'Universa-Surgical-Company-Brochure-2025.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    toast.success('Downloading brochure...', {
      description: 'Your company brochure download has started.'
    });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-4xl font-bold mb-4">Download Our Product Catalogs</h2>
          <p className="text-xl mb-8 text-gray-300 max-w-3xl mx-auto">
            Browse our complete range of luxury beauty instruments. Available in PDF format for easy reference.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black font-semibold"
              onClick={handleQuickDownload}
            >
              <Download className="w-5 h-5 mr-2" />
              Company Brochure
            </Button>
            <Link to="/catalogs">
              <Button 
                size="lg" 
                variant="outline" 
                className="border-yellow-500 text-yellow-400 hover:bg-yellow-500 hover:text-black"
              >
                <FileText className="w-5 h-5 mr-2" />
                View All Catalogs
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export const ContactCTASection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Ready to Order?</h2>
        <p className="text-xl text-gray-600 mb-8">
          Contact us today for quotes, custom orders, or any inquiries about our luxury beauty instruments
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button size="lg" className="bg-gradient-to-r from-yellow-600 to-yellow-500 hover:from-yellow-500 hover:to-yellow-400 text-black font-semibold">
              Get a Quote <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
          <Link to="/about">
            <Button size="lg" variant="outline" className="border-yellow-600 text-yellow-700 hover:bg-yellow-50">
              Learn More About Us
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
